import { Bird } from '../../api/birds';
import { BirdStatus } from '../../utils/enums';

export const CHECKLIST_ELIGIBLE_STATUSES: BirdStatus[] = [
  BirdStatus.PAIRED,
  BirdStatus.AVAILABLE,
  BirdStatus.FOR_SALE,
];

export function filterChecklistBirds(birds: Bird[], cageNumber?: string): Bird[] {
  let filtered = birds.filter((bird) =>
    CHECKLIST_ELIGIBLE_STATUSES.includes(bird.status as BirdStatus),
  );
  if (cageNumber) {
    filtered = filtered.filter((bird) => bird.cageNumber === cageNumber);
  }
  return filtered.sort((a, b) => a.bandId.localeCompare(b.bandId));
}

export function checklistCageOptions(birds: Bird[]): string[] {
  const cages = new Set<string>();
  birds
    .filter((bird) => CHECKLIST_ELIGIBLE_STATUSES.includes(bird.status as BirdStatus))
    .forEach((bird) => {
      if (bird.cageNumber?.trim()) cages.add(bird.cageNumber.trim());
    });
  return Array.from(cages).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
}
